export default "__VITE_ASSET__WWDS0EGE__"